const ClaimFormSchema = {
    claimNumber: {
        required: { value: true, message: 'Claim Number is required.' },
        maxLength: { value: 25, message: 'Claim Number should be 17 characters long.' }
    },
    contractNumber: {
        required: { value: true, message: 'Contract Number is required.' },
        maxLength: { value: 25, message: 'Contract Number allows up to 25 characters long.' }
    },
    lastName: {
        required: { value: true, message: 'Last Name is required.' },
        maxLength: { value: 30, message: 'Last Name allows up to 30 characters long.' },
        minLength: { value: 2, message: 'Last Name should be at least 2 characters.' }
    }
};

export default ClaimFormSchema;